import { render, staticRenderFns } from "./NormalUserIcon.vue?vue&type=template&id=32038526&"
import script from "./NormalUserIcon.vue?vue&type=script&setup=true&lang=js&"
export * from "./NormalUserIcon.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports